/*
  LRDC — recherche (port de CategorySearch.tsx). Sélecteur de CATÉGORIE (product_type)
  qui PERSISTE et SCOPE la recherche via l'opérateur natif Shopify « q=terme product_type:"X" »
  (aucune app requise). Suggestions en direct via /search/suggest.json (predictive search natif).
*/
(function () {
  var form = document.querySelector('[data-lrdc-search-form]');
  if (!form) return;
  var routeSearch = (window.Shopify && Shopify.routes && Shopify.routes.search_url) || '/search';
  var input = form.querySelector('[data-lrdc-q]');
  var cat = form.querySelector('[data-lrdc-cat]');
  var box = document.querySelector('[data-lrdc-suggest]');
  var i18nEl = document.querySelector('[data-lrdc-search-i18n]');
  var T = {}; try { T = JSON.parse(i18nEl.textContent); } catch (e) {}
  var TYPES = []; try { TYPES = JSON.parse(document.querySelector('[data-lrdc-types]').textContent); } catch (e) {}
  function tr(k) { return T[k] || k; }
  // Libellé d'affichage d'une catégorie (product_type) : traduit en EN via le helper
  // global. La VALEUR envoyée (option.value / data-sg-cat / q=product_type:"…") reste
  // le product_type réel en français ; seul l'affichage change.
  function catLabel(v) { return (window.LRDCCatLabel ? window.LRDCCatLabel(v) : v) || v; }

  // Traduire l'AFFICHAGE des options du sélecteur de catégorie en EN (valeur FR conservée).
  if (cat) {
    for (var oi = 0; oi < cat.options.length; oi++) {
      var opt = cat.options[oi];
      if (!opt.value) continue; // « Toutes catégories »
      var disp = catLabel(opt.value);
      if (disp !== opt.value) {
        var mcount = opt.textContent.match(/\s*\((\d+)\)\s*$/);
        opt.textContent = disp + (mcount ? ' (' + mcount[1] + ')' : '');
      }
    }
  }

  // Ré-sélectionner la catégorie depuis l'URL (persistance après recherche)
  var params = new URLSearchParams(window.location.search);
  var curCat = params.get('cat');
  if (curCat && cat) {
    for (var i = 0; i < cat.options.length; i++) { if (cat.options[i].value === curCat) { cat.value = curCat; break; } }
  }

  function buildQ(term, type) {
    var q = term.trim();
    if (type) q += (q ? ' ' : '') + 'product_type:' + JSON.stringify(type); // JSON.stringify => guillemets pour multi-mots
    return q;
  }
  function goSearch(term, type) {
    var q = buildQ(term, type);
    var url = routeSearch + '?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last';
    if (type) url += '&cat=' + encodeURIComponent(type);
    window.location.href = url;
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var term = input.value.trim();
    var type = cat ? cat.value : '';
    if (!term && !type) return; // rien à faire
    goSearch(term, type);
  });

  // ---------- suggestions en direct ----------
  var esc = function (s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var tmr, ctrl;
  function closeBox() { if (box) { box.hidden = true; box.innerHTML = ''; } }
  function renderSuggest(term, products) {
    if (!box) return;
    var html = '';
    var t = term.trim().toLowerCase();
    var selType = cat ? cat.value : '';
    // Si une catégorie est déjà choisie, on ne propose pas de puces de catégorie
    // (la recherche est déjà scopée) ; sinon on suggère les catégories qui matchent.
    var catMatches = (!selType && t.length >= 2) ? TYPES.filter(function (c) { return c.name.toLowerCase().indexOf(t) !== -1; }).slice(0, 4) : [];
    if (catMatches.length) {
      html += '<div class="lrdc-sg__group"><p class="lrdc-sg__label">' + esc(tr('categories')) + '</p>';
      catMatches.forEach(function (c) {
        html += '<button type="button" class="lrdc-sg__cat" data-sg-cat="' + esc(c.name) + '"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 12v-2a2 2 0 0 0-2-2h-6l-2-2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h6"/></svg><span class="lrdc-sg__cat-name">' + esc(catLabel(c.name)) + '</span><span class="lrdc-sg__cat-n">' + c.count + '</span></button>';
      });
      html += '</div>';
    }
    if (products.length) {
      html += '<div class="lrdc-sg__group"><p class="lrdc-sg__label">' + esc(tr('products')) + '</p>';
      products.forEach(function (p) {
        var img = '<img src="' + esc(p.image || window.LRDC_PH || '') + '" alt="" loading="lazy">';
        html += '<a class="lrdc-sg__item" href="' + esc(p.url) + '"><span class="lrdc-sg__thumb">' + img + '</span><span class="lrdc-sg__meta"><span class="lrdc-sg__title">' + esc(p.title) + '</span>' + (p.type ? '<span class="lrdc-sg__type">' + esc(catLabel(p.type)) + '</span>' : '') + '</span></a>';
      });
      html += '</div>';
    }
    if (!html) { closeBox(); return; }
    box.innerHTML = html;
    box.hidden = false;
  }
  function fetchSuggest(term) {
    if (ctrl) ctrl.abort();
    ctrl = new AbortController();
    // Scoper les suggestions à la catégorie choisie via l'opérateur natif product_type:
    // (Shopify predictive respecte cet opérateur → suggestions cohérentes avec le sélecteur).
    var selType = cat ? cat.value : '';
    var sq = buildQ(term, selType);
    var url = '/search/suggest.json?q=' + encodeURIComponent(sq) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
    fetch(url, { signal: ctrl.signal, headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var raw = ((d.resources || {}).results || {}).products || [];
        var products = raw.map(function (p) {
          return { title: p.title, url: p.url, type: p.type || '', image: (p.featured_image && p.featured_image.url) || p.image || '' };
        });
        renderSuggest(term, products);
      })
      .catch(function () {});
  }
  if (input) {
    input.addEventListener('input', function () {
      var term = input.value.trim();
      clearTimeout(tmr);
      if (term.length < 2) { closeBox(); return; }
      tmr = setTimeout(function () { fetchSuggest(term); }, 250);
    });
    input.addEventListener('focus', function () { if (input.value.trim().length >= 2 && box && box.innerHTML) box.hidden = false; });
  }
  // Rafraîchir les suggestions quand on change la catégorie (pour qu'elles restent scopées).
  if (cat) cat.addEventListener('change', function () {
    var term = input ? input.value.trim() : '';
    if (term.length >= 2) fetchSuggest(term); else closeBox();
  });
  // Clic sur une catégorie suggérée -> scope + recherche
  if (box) box.addEventListener('click', function (e) {
    var c = e.target.closest('[data-sg-cat]');
    if (c) { e.preventDefault(); goSearch(input.value.trim(), c.getAttribute('data-sg-cat')); }
  });
  // Fermer au clic extérieur
  document.addEventListener('mousedown', function (e) {
    if (box && !box.hidden && !box.contains(e.target) && e.target !== input) closeBox();
  });
})();
